<mat-card class="p-4">
  <h3 class="mb-2 text-lg font-semibold">Bulk import</h3>
  <p class="mb-3 text-sm">Upload a CSV file to import employees in bulk.</p>
  <p class="mb-2 text-sm font-semibold">Required import fields</p>
  <p class="mb-3 text-xs">
    Unique company code, Company client code, Company Name, Classification, Product Type, Title, Name, Surname,
    Employee number, ID Nr, Date of employment, ExtractDate, Date of birth, Employment Type, Job title,
    Contact Number, Email address, Manager, Province, CurrentLevel1, CurrentLevel2, Status.
  </p>

  <div class="flex items-center gap-3">
    <input #fileInput type="file" accept=".csv,text/csv" (change)="onFileSelected($event)" [disabled]="busy()" class="hidden" />
    <button mat-flat-button color="primary" type="button" (click)="fileInput.click()" [disabled]="busy()">Add import file</button>
    <button mat-stroked-button type="button" (click)="clearSelection(fileInput)" [disabled]="busy()">Clear</button>
  </div>

  @if (status() === 'uploading') {
    <p class="mt-2 text-sm">Uploading...</p>
  }

  @if (status() === 'failed') {
    <div class="mt-2">
      <button mat-button type="button" (click)="retry()" [disabled]="busy()">Retry upload</button>
    </div>
  }
</mat-card>
